import React from 'react';
import { Check, Star } from 'lucide-react';
import './MonthlyPlans.css';

const plansData = [
  {
    name: 'Starter White-Label Support',
    price: '₹29,999',
    period: '/ month',
    hours: 'Up to 30 hours / month',
    popular: false,
    features: [
      'Small tasks, bug fixes, improvements',
      'Email + WhatsApp support',
      '48–72 hr turnaround',
      'Monthly planning call',
      'Non-stackable hours'
    ]
  },
  {
    name: 'Growth White-Label Partner',
    price: '₹49,999 – ₹59,999',
    period: '/ month',
    hours: 'Up to 60–80 hours / month',
    popular: true,
    features: [
      'Everything in Starter +',
      'Active development & feature work',
      'Priority task handling',
      'Faster turnaround times',
      'Weekly planning call',
      'Product-level technical involvement',
      'Ideal for scaling agencies'
    ]
  },
  {
    name: 'Dedicated Laravel Partner',
    price: '₹79,999 – ₹1,50,000',
    period: '/ month',
    hours: 'Up to 100–160 hours / month',
    popular: false,
    features: [
      'Everything in Growth +',
      'Reserved dedicated capacity',
      'High-priority task queue',
      'Architecture & long-term support',
      'Extended backend team',
      'Non-stackable hours'
    ]
  }
];

const MonthlyPlans = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="monthly-plans-section">
      <div className="monthly-plans-container">
        <div className="monthly-plans-header">
          <h2 className="section-title">Monthly White-Label Partnership Plans</h2>
          <p className="section-description">
            Flexible monthly engagements for ongoing Laravel development needs
          </p>
        </div>
        
        <div className="plans-grid">
          {plansData.map((plan, index) => (
            <div key={index} className={`plan-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && (
                <div className="popular-badge">
                  <Star size={16} fill="currentColor" />
                  Most Popular
                </div>
              )}
              
              <h3 className="plan-name">{plan.name}</h3>
              <div className="plan-price">
                <span className="price">{plan.price}</span>
                <span className="period">{plan.period}</span>
              </div>
              <div className="plan-hours">{plan.hours}</div>
              
              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="plan-feature">
                    <Check size={20} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button className="plan-cta" onClick={scrollToContact}>
                Get Started
              </button>
            </div>
          ))}
        </div>
        
        <div className="plans-note">
          <p><strong>Important:</strong> Unused hours do not roll over.</p>
          <p>If scope exceeds plan hours, work is billed separately or plan is upgraded.</p>
          <p>Final scope confirmed before starting.</p>
        </div>
      </div>
    </section>
  );
};

export default MonthlyPlans;